import { Box, Typography } from '@mui/material'
import React from 'react'
import { MuiButton, MuiImage } from '../../../../components'
import { IS_SCREEN_BELOW_1366, MAGNET_SCORE_IMAGE } from '../../../../constants'
import { getImageUrl } from '../../../../util'
import { ArrowButtons, SliderWrapper, StyledCellWrap } from './style'
import Slider from 'react-slick'
import { IconArrowSwipeLeft, IconArrowSwipeRight } from '../../../../assets/images/icons'
import { useGlobalStore } from '../../../../store'

const LandScapeHeader = React.forwardRef(({ scores = [], showScore, onSliderChange, currentSlide, showSlider, slideWrapperWidth }, sliderRef, ) => {
  // const listWidth = (scores.length < 1) ? '300px' : `${100 / (scores.length)}%`
  const { isFullScreen } = useGlobalStore();
  
  const defaultCarouselSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 6.7,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    swipeToSlide: false,
    draggable: false,
    touchMove: false,
    initialSlide: currentSlide,
    speed: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: function (currentSlide, nextSlide) {
      // Notify parent component about slide change
      if (onSliderChange) {
        onSliderChange(nextSlide);
      }
    },
    afterChange: function (currentSlide) {
      if (onSliderChange) {
        onSliderChange(currentSlide);
      }
      // console.log("after change", currentSlide);
    },
  }

  return (
    <>
      {!showSlider ? 
      scores?.map((item) => {
        // const imgObj = MAGNET_SCORE_IMAGE?.[item?.logo]
        const imgObj = getImageUrl('logos', item?.logo, 'png')

        return (
          <StyledCellWrap
            className='listHeading'
            alignItems='center'
            padding='10px'
            key={item.name}
            borderLeft='0 !important'
            borderBottom='1px solid rgba(0, 0, 0, 1)'
            margin='12px 6px 0'
            marginTop='25px !important'
            // width={listWidth}
            // width={`${100 / (scores.length + 1)}%`}
            sx={{
              background: 'transparent !important',
              ":last-child": {
                marginRight: '0'
              }
            }}
          >
            <MuiImage src={imgObj} alt={imgObj} />
            {/* <MuiImage src={imgObj?.icon} width={imgObj.width} height={imgObj.height} /> */}
            {item.score &&
              <Typography color={'rgba(233, 121, 23, 1)'} lineHeight={'19px'} fontWeight={600} marginTop='10px' display={'flex'} alignItems={'center'} gap={'4px'}>
              <MuiImage src={MAGNET_SCORE_IMAGE['Start'].icon} width='15px' height='15px' />
              {item.score}
            </Typography>
            }
          </StyledCellWrap>
        )
      }) :
        <SliderWrapper slideWrapperWidth={slideWrapperWidth} mdScreen={IS_SCREEN_BELOW_1366()} isFullScreen={isFullScreen}>
        <Slider {...defaultCarouselSettings} ref={sliderRef}>
          {scores?.map((item) => {

            const imgObj = getImageUrl('logos', item?.logo, 'png')

            return (
              <StyledCellWrap
                className='listHeading'
                alignItems='center'
                padding='10px'
                key={item.name}
                borderLeft='0 !important'
                borderBottom='1px solid rgba(0, 0, 0, 1)'
                margin='12px 6px 0'
                marginTop='25px !important'
                // width={`${100 / (scores.length + 1)}%`}
                sx={{
                  background: 'transparent !important',
                }}
              >
                <MuiImage src={imgObj} alt={imgObj} />
                {/* <MuiImage src={imgObj?.icon} width={imgObj.width} height={imgObj.height} /> */}
                {item.score && 
                <Typography color={'rgba(233, 121, 23, 1)'} lineHeight={'19px'} fontWeight={600} marginTop='10px' display={'flex'} alignItems={'center'} gap={'4px'}>
                  <MuiImage src={MAGNET_SCORE_IMAGE['Start'].icon} width='15px' height='15px' />
                  {item.score}
                </Typography>
                }
              </StyledCellWrap>
            )
          })}
        </Slider>
      </SliderWrapper>
      }

    </>
  )
});

export default LandScapeHeader

export function PrevArrow(props) {
  const { className, onClick, style, onExtraClick } = props
  return (
    <ArrowButtons
      className={`${className} prev-btn`}
      onClick={(e) => {
        onClick(e);
        onExtraClick();
      }}
      style={style ? { ...style } : undefined}
      startIcon={<IconArrowSwipeLeft />}
      variant='contained'
      color='secondary'
    >
    </ArrowButtons>
  )
}

export function NextArrow(props) {
  const { className, onClick, style, onExtraClick } = props
  return (
    <ArrowButtons
      className={`${className} next-btn`}
      onClick={(e) => {
        onClick(e);
        onExtraClick();
      }}
      style={style ? { ...style } : undefined}
      startIcon={<IconArrowSwipeRight />}
      variant='contained'
      color='secondary'
    >
    </ArrowButtons>
  )
}
